import type { Optional, Server } from '@festina-life/core'
import { createContext, useContext } from 'react'

export type CommandActionVariant =
  | 'read'
  | 'update'
  | 'create'
  | 'cancel'
  | 'approve'
  | 'approvePendingCancellation'
  | 'declinePendingCancellation'

export type CommandActionVariantOrSimulation =
  | CommandActionVariant
  | 'simulationOnly'

export type DataContextType<T> = {
  data?: Optional<T>
  eventId?: Optional<string>
  previousEventId?: Optional<string>
  applyDate?: Optional<string>
  expectedApplyDate?: Optional<string>
  shouldSkipFrame: boolean
  commandId: Optional<string>
  commandActionVariant: CommandActionVariantOrSimulation | undefined
  festinaComponent: Server | undefined
  isAllowedToSimulationAndFetchForFrame: boolean
}

const DataContext = createContext<DataContextType<unknown>>(
  {} as DataContextType<unknown>,
)

const useDataContext = <T>() => {
  const context = useContext(DataContext)

  return context as DataContextType<T>
}
const Provider = DataContext.Provider

export { Provider, useDataContext }
